import { render, staticRenderFns } from "./BannerWrapper.vue?vue&type=template&id=371face0&scoped=true"
import script from "./BannerWrapper.vue?vue&type=script&lang=ts"
export * from "./BannerWrapper.vue?vue&type=script&lang=ts"
import style0 from "./BannerWrapper.vue?vue&type=style&index=0&id=371face0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371face0",
  null
  
)

export default component.exports